import {createSlice, createAsyncThunk, PayloadAction} from "@reduxjs/toolkit";

import axios from "axios";
import {deleteProjectApi, projectListApi} from "../../api";
import IPConstants from "../../classes/IPConstants";
import {deleteProjectRequest, IPProject, IPProjectListRequest} from "../../models/IPProject";
import {toastPopupOpenAction} from "./interactionReducer";

export const getProjectList = createAsyncThunk(
  "/projectList",
  async (params: IPProjectListRequest) => {
    try {
      const requestParams: IPProjectListRequest = {
        userToken: params.userToken,
        page: params.page,
        rowCount: params.rowCount,
        searchWord: params.searchWord,
        isAll: params.isAll,
        year: params.year,
        region: params.region,
        grade: params.grade,
      };
      sessionStorage.setItem("projectListParams", JSON.stringify(params));
      return await axios.post(projectListApi, requestParams).then((res) => res.data);
    } catch (error) {
      alert(error);
      console.log(error);
      throw new Error("네트워크 에러");
    }
  }
);

export const deleteProject = createAsyncThunk(
  "/deleteProject",
  async (params: deleteProjectRequest, {dispatch}) => {
    try {
      const requestParams: deleteProjectRequest = {
        userToken: params.userToken,
        id: params.id,
      };
      return await axios
        .post(deleteProjectApi, requestParams)
        .then((res) => res.data)
        .then((data) => {
          if (data !== undefined && data.message.indexOf(IPConstants.successMessage) > -1) {
            dispatch(
              toastPopupOpenAction({
                contents: "프로젝트가 삭제되었습니다.",
                severity: "info",
              })
            );
            const param = sessionStorage.getItem("projectListParams");
            if (param) dispatch(getProjectList(JSON.parse(param)));
            // if (params.successHandler) params.successHandler();
          } else
            dispatch(
              toastPopupOpenAction({
                contents: "프로젝트 삭제에 실패했습니다.",
                severity: "warning",
              })
            );

          return data;
        });
    } catch (error) {
      throw new Error("네트워크 에러");
    }
  }
);

type filteringType = {
  year: number;
  region: number;
  grade: number;
};
interface projectList {
  loading: boolean;
  projectList: IPProject[];
  error: string;
  maxPage: number;
  message: string;
  currentUid: number;
  switchChecked: boolean;
  filtering: filteringType;
  tableHeader: string[];
  addProjectTableHeader: string[];
}

const initialState: projectList = {
  loading: false,
  projectList: [],
  error: "",
  maxPage: 0,
  message: "",
  currentUid: 0,
  switchChecked: false,
  filtering: {
    year: 9999,
    region: 9999,
    grade: 9999,
  },
  tableHeader: [
    "ID",
    "대상년도",
    "사업장명",
    "프로젝트명",
    "등록일",
    "등록자",
    "참여자",
    // "도움말",
    "편집",
    "삭제",
    "파일생성",
    "첨부파일",
  ],
  addProjectTableHeader: ["ID", "대상년도", "사업장명", "프로젝트명", "등록자", "참여자", "편집"],
};

const ProjectListSlice = createSlice({
  name: "projectList",
  initialState,
  reducers: {
    deleteProjectAction: (state, {payload}: PayloadAction<number | null>): void => {
      const filtering = state.projectList?.filter((project) => project.uid !== payload);
      state.projectList = filtering;
    },
    currentUidAction: (state, {payload}: PayloadAction<number>): void => {
      state.currentUid = payload;
    },
    searchingProjectAction: (state, {payload}: PayloadAction<string>) => {
      const searching = state.projectList?.filter((project) =>
        project.name.toLowerCase().trim().includes(payload.toLowerCase().trim())
      );
      state.projectList = searching;
    },
    switchCheckedAction: (state): void => {
      state.switchChecked = !state.switchChecked;
    },

    filteringAction: (state, {payload}: PayloadAction<filteringType>) => {
      state.filtering = payload;
    },
  },
  extraReducers: {
    [getProjectList.pending.type]: (state) => {
      state.loading = true;
    },
    [getProjectList.fulfilled.type]: (state, action) => {
      state.loading = false;
      state.projectList = action.payload.items;
      state.message = action.payload.message;
      state.maxPage = action.payload.maxPage;
    },
    [getProjectList.rejected.type]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },
    [deleteProject.pending.type]: (state) => {
      state.loading = true;
    },
    [deleteProject.fulfilled.type]: (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
      if (action.payload.message.indexOf(IPConstants.successMessage) > -1) {
      }
    },
    [deleteProject.rejected.type]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },
  },
});

export const {deleteProjectAction, currentUidAction, switchCheckedAction, filteringAction} =
  ProjectListSlice.actions;
export default ProjectListSlice.reducer;
